// Pure helpers for the CreateCancellationRequest popup, imported by tests/createCancellationRequest.check.ts.

// Any one of these roles unlocks the full reason list and future cancellation. Popup-only:
// the API does not enforce it.
export const PRIVILEGED_ROLES = ['admin', 'money', 'agents_moderator']

// Submitted for non-privileged users until they pick an alternative. Not a dropdown option for them.
export const RESTRICTED_DEFAULT_REASON = 'CUSTOMER_REQUEST'
const RESTRICTED_REASONS = ['RIP', 'OTHER']

// Exactly the backend's SUPERSEDABLE_REASONS (api CancellationRequestController.CreateCancellationRequest).
const SUPERSEDABLE_REASONS = ['UPGRADE', 'CHANGE_SUBSCRIPTION', 'RIP']

export const REASON_OPTIONS = [
    { value: 'UPGRADE', label: 'שדרוג' },
    { value: 'CHANGE_SUBSCRIPTION', label: 'שינוי מינוי' },
    { value: 'CUSTOMER_REQUEST', label: 'לבקשת הלקוח' },
    { value: 'MISTAKE', label: 'טעות בסוג המינוי' },
    { value: 'DENIAL_OF_TRANSACTION', label: 'הכחשת עסקה' },
    { value: 'STO_CANCELLED', label: 'ביטול הוראת קבע' },
    { value: 'RETURNED_CHARGE', label: 'חיוב חוזר' },
    { value: 'BLOCKING_PAYMENT_METHOD', label: 'חסימת אמצעי תשלום' },
    { value: 'RIP', label: 'פטירת לקוח' },
    { value: 'OTHER', label: 'סיבה אחרת' }
]

export const isPrivilegedUser = (roles: string[] | null | undefined) =>
    !!roles && PRIVILEGED_ROLES.some(role => roles.indexOf(role) !== -1)

// Superseding a valid future cancellation narrows either list to the backend's supersedable reasons.
export const getReasonOptions = (privileged: boolean, hasValidFuture: boolean) =>
    REASON_OPTIONS.filter(
        ({ value }) =>
            (privileged || RESTRICTED_REASONS.indexOf(value) !== -1) &&
            (!hasValidFuture || SUPERSEDABLE_REASONS.indexOf(value) !== -1)
    )

// CUSTOMER_REQUEST cannot supersede, so a restricted user facing a valid future cancellation starts
// empty and must pick RIP.
export const getDefaultReason = (privileged: boolean, hasValidFuture: boolean) =>
    privileged || hasValidFuture ? '' : RESTRICTED_DEFAULT_REASON

export const getReasonLabel = (reason: string) => {
    const option = REASON_OPTIONS.find(({ value }) => value === reason)
    return option ? option.label : reason
}

export const canScheduleFutureCancellation = (privileged: boolean, isSpecialSub: boolean, hasValidFuture: boolean) =>
    privileged && !isSpecialSub && !hasValidFuture

// Same predicate as the checkbox's visibility, so stale state can never leak a date into the payload.
export const getSubmittedFutureDate = (canScheduleFuture: boolean, futureCancellation: boolean, futureDate: string) =>
    canScheduleFuture && futureCancellation && futureDate ? futureDate : null

export const BLOCKING_STATUSES = ['OPEN', 'IN_PROGRESS', 'HANDLE_REQUIRE', 'AWAITING_PAYMENT']
